import { type FC } from 'react'
import { Box } from '@mui/material'
import { InfoGraphic } from '@dhl/info-graphic'
import { CarParts } from '@dhl/illustrations'

export const MaintenancePage: FC = () => (
  <Box pt="35vh">
    <InfoGraphic
      dataTestId="maintenance-page"
      graphic={CarParts}
      title="maintenance.page.titleText"
      description="maintenance.page.description"
    />
  </Box>
)
